module.exports = __webpack_public_path__ + "img/dance-school-icon2.b33463ec.png";